import $ from 'jquery';



export default class Tag {
  constructor(container) {
    this.container = container;
  }
  init() {
    const $tags = $('.tag', this.container);
    $tags.each(function () {
      const w = $(this).innerWidth();
      $(this).css({
        'transform': ' translateX(-' + (w) + 'px) rotate(-90deg)',
        'opacity': 1
      });
    });
  }
}